import Wrapper from '../Wrapper';

import React,{Component} from 'react';

import './About.less';

class About extends Component{

  constructor(props){
    super(props);
    this.state = {
      lang: 'Deutsch'
    }
  }

  columnCount = () => {
    const {res} = this.props;

    let ret = 1;

    switch(res){
      case 'xlarge':
        ret = 4;
        break;
      case 'large':
        ret = 3;
        break;
      case 'medium':
        ret = 2;
        break;
      case 'small':
        ret = 1;
        break;
    }

    return ret;
  }

  render(){
    const {lang} = this.state;
    const {data} = this.props;
    const {about} = data;
    const content = lang == 'Deutsch' ? about.de : about.en;
    return (
      <Wrapper title="The Prosecution" menuItems={['Deutsch', 'Englisch']} menuAction={lang => this.setState({lang})} {...this.props}>
        <p className={'about-text'} dangerouslySetInnerHTML={{__html:content}} style={{columnCount: this.columnCount()}}></p>
      </Wrapper>
    )
  }
}

export default About



// WEBPACK FOOTER //
// ./src/components/sections/About.js